import { defineComponent as n, createBlock as a, openBlock as l, unref as p, mergeProps as c, withCtx as d, createElementVNode as o } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const v = /* @__PURE__ */ n({
  name: "IconPowerAdapterApple",
  __name: "IconPowerAdapterApple",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const r = t;
    return (i, e) => (l(), a(p(m), c(r, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        o("path", { d: "M10.616 7.882 7.993 11.98a.5.5 0 0 0 .42.77H10.5l-.662 3.144c-.069.326.366.505.546.224l2.624-4.1a.5.5 0 0 0-.422-.769H10.5l.662-3.145c.069-.326-.366-.504-.546-.223" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M2.75 7.5A3.25 3.25 0 0 1 6 4.25h9a3.25 3.25 0 0 1 3.24 3h2.26a.75.75 0 0 1 0 1.5h-2.25v7.75A3.25 3.25 0 0 1 15 19.75H6a3.25 3.25 0 0 1-3.25-3.25v-9m14 0v9A1.75 1.75 0 0 1 15 18.25H6a1.75 1.75 0 0 1-1.75-1.75v-9A1.75 1.75 0 0 1 6 5.75h9a1.75 1.75 0 0 1 1.75 1.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
